
(function() {
  const PFAND_VARIANTS = {
    "25": 53558735274311,
    "15": 53558781739335,
    "8": 53558783508807
  };
 
  let syncTimeout = null;
 
  async function syncPfand() {
    const cartResp = await fetch('/cart.js');
    const cart = await cartResp.json();
 
    let required = { "25": 0, "15": 0, "8": 0 };
    let pfandInCart = { "25": 0, "15": 0, "8": 0 };
 
    cart.items.forEach(item => {
      const isPfand = Object.values(PFAND_VARIANTS).includes(item.variant_id);
      if (isPfand) {
        const type = Object.keys(PFAND_VARIANTS).find(k => PFAND_VARIANTS[k] === item.variant_id);
        if (type) pfandInCart[type] += item.quantity;
        return;
      }
      const pfandValue = item.properties && item.properties['_pfand'];
      if (pfandValue) {
        const key = String(pfandValue);
        required[key] = (required[key] || 0) + item.quantity;
      }
    });
 
    const updates = {};
    let hasChanges = false;
 
    ["25", "15", "8"].forEach(type => {
      const req = required[type];
      const curr = pfandInCart[type];
      if (req !== curr) {
        updates[PFAND_VARIANTS[type]] = req;
        hasChanges = true;
      }
    });
 
    if (hasChanges) {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      const updatedCart = await response.json();
 
      document.querySelectorAll('.header__cart-count-number').forEach(el => {
        el.textContent = updatedCart.item_count;
      });
 
      if (window.location.pathname === '/cart') {
        window.location.replace(window.location.href);
      } else {
        // Drawer neu laden damit Pfand-Menge korrekt angezeigt wird
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      }
    }
  }
 
  function debouncedSync() {
    clearTimeout(syncTimeout);
    syncTimeout = setTimeout(syncPfand, 500);
  }
 
  window.addEventListener('load', syncPfand);
  document.addEventListener('on:line-item:change', debouncedSync);
  document.addEventListener('on:cart:add', debouncedSync);
 
  // Sync auch beim Öffnen des Drawers als Absicherung
  document.addEventListener('dispatch:cart-drawer:open', function() {
    clearTimeout(syncTimeout);
    syncTimeout = setTimeout(syncPfand, 200);
  });
})();